import React, { version } from "react";
import ManualTree from "./ManualTree";
import Blocker from "../../Misc/Blocker";
import Context from "../../../Context";
import ManualCrumbs from "./ManualCrumbs";
import CrumbsProvider from "../../Misc/CrumbsProvider";
import TemplatesList from "../../Essence/Templates/TemplatesList";
import BigError from "../../Misc/BigError";
import TemplateEdit from "../../Essence/Templates/TemplateEdit";
import ManualView from "./ManualView";
import SVGLayout1 from "../../Misc/SvgIcons/SVGLayout1";
import ManualFolders from "./ManualFolders";
import SVGFolder1 from "../../Misc/SvgIcons/SVGFolder1";
import ManualAddButton from "./ManualAddButton";
import visualState from "../../../visualState";

export default class Manual extends React.Component {
  static contextType = Context;

  constructor(props) {
    super(props);

    this.vState = new visualState("ManualSection");

    this.state = {
      structureSelected: [],
      structureExpanded: [],
      structureItems: {},
      structureItemsSearchDefault: [
        {
          lstr: "(",
          field: "statetypecode",
          compare: "EQL",
          value: "enabled",
        },
        {
          field: "typecode",
          compare: "EQL",
          value: "ism.structure",
          rstr: ")",
        },
      ],

      structure: props.structure,
      document: props.document,
      mode: props.mode,
      version: props.version,
      copyObjId: this.getCopyObjId(),
      pending: false,
      treeVisible: this.vState.read("treeVisible", true),
      foldersVisible: this.vState.read("foldersVisible", true),
      foldersGrid: this.vState.read("foldersGrid", true),
    };
  }

  componentDidMount() {
    this.load();
    this.renderButtons();
  }

  componentDidUpdate(prevProps) {
    if (prevProps.structure !== this.props.structure) {
      this.setState({ structure: this.props.structure });
      this.treeRestoreExpanded(this.props.structure);
    }
    if (prevProps.document !== this.props.document) {
      this.setState({ document: this.props.document });
    }

    if (prevProps.mode !== this.props.mode) {
      this.setState({ mode: this.props.mode });
    }

    if (prevProps.version !== this.props.version) {
      this.setState({ version: this.props.version });
    }

    let copyObjId = this.getCopyObjId();
    if (this.state.copyObjId !== copyObjId) {
      this.setState({ copyObjId });
    }

    this.renderButtons();
  }

  getCopyObjId = () => {
    let searchParams = new URLSearchParams(
      this.props.location.search.substr(1)
    );
    return searchParams.get("copy");
  };

  load = async () => {
    this.setState({ pending: true });
    let structureItems = await this.context.api.qoo(
      `/structure/list`,
      { search: this.state.structureItemsSearchDefault },
      undefined,
      undefined,
      undefined,
      "node",
      "sequence"
    );

    this.setState({ pending: false, structureItems }, () =>
      this.treeRestoreExpanded(this.props.structure)
    );
  };

  onVersionChange = (version = {}) => {
    const { structure, document, mode = "view" } = this.state;
    this.context.redirect(
      `/manual/${structure}/${document}/${mode}/${version.id || ""}`
    );
  };

  treeHandleToggle = (event, nodeIds) => {
    this.setState({ structureExpanded: nodeIds });
  };
  treeHandleSelect = (event, nodeIds) => {
    /* let structure = Array.isArray(nodeIds) ? nodeIds[0] : nodeIds;
    event.preventDefault();
    this.setState({
      structureSelected: structure,
      structure: structure,
      document: null,
      mode: null,
    });
    window.history.pushState({}, null, `/manual/${structure}/`);*/
  };
  treeGetPath = (id) => {
    let result = [];
    const items = this.state.structureItems;
    if (id && Object.keys(items).length > 0) {
      if (items[`_${id}`]) {
        let parentNodeId = items[`_${id}`].node;
        result = [String(id)];
        while (parentNodeId) {
          if (items[`_${parentNodeId}`]) {
            result.push(String(parentNodeId));
            parentNodeId = items[`_${parentNodeId}`].node;
          } else {
            parentNodeId = false;
          }
        }
      }
    }
    return result.reverse();
  };
  treeRestoreExpanded = (id) => {
    if (!id) {
      this.setState({ structureExpanded: [], structureSelected: [] });
    } else {
      const expanded = this.treeGetPath(id);
      this.setState({ structureExpanded: expanded, structureSelected: id });
    }
  };
  treeTogleVisible = () => {
    this.setState((state) => {
      this.vState.save({ treeVisible: !state.treeVisible });
      return { treeVisible: !state.treeVisible };
    });
  };

  foldersTogleVisible = () => {
    this.setState((state) => {
      this.vState.save({ foldersVisible: !state.foldersVisible });
      return { foldersVisible: !state.foldersVisible };
    });
  };
  foldersToggleView = (isGrid) => {
    this.vState.save({ foldersGrid: isGrid });
    this.setState({ foldersGrid: isGrid });
  };

  renderButtons = () => {
    if (this.state.mode !== "edit" && this.state.mode !== "add") {
      this.context.actionsSet(
        <>
          <button
            title="Отображение структуры"
            onClick={this.treeTogleVisible}
            className={`btn btn-icon ${
              this.state.treeVisible
                ? "bg-light-primary bg-hover-light"
                : "bg-light bg-hover-light-primary"
            }    mr-2`}
          >
            <span
              className={`svg-icon ${
                this.state.treeVisible ? "svg-icon-primary" : "svg-icon-light"
              } `}
            >
              <SVGLayout1 />
            </span>
          </button>
          <button
            title="Отображение папок"
            onClick={this.foldersTogleVisible}
            className={`btn btn-icon ${
              this.state.foldersVisible
                ? "bg-light-primary bg-hover-light"
                : "bg-light bg-hover-light-primary"
            }    mr-2`}
          >
            <span
              className={`svg-icon ${
                this.state.foldersVisible
                  ? "svg-icon-primary"
                  : "svg-icon-light"
              } `}
            >
              <SVGFolder1 />
            </span>
          </button>
          {this.state.structure ? (
            <ManualAddButton
              structure={
                this.state.treeVisible || this.state.foldersVisible
                  ? this.state.structure
                  : null
              }
              disallow={["workdoc"]}
              essence="manual"
            />
          ) : null}
        </>
      );
    }
  };

  render() {
    //Render structure not found
    if (
      !this.state.pending &&
      this.state.structure &&
      this.state.structure !== "all" &&
      !this.state.structureItems[`_${this.state.structure}`]
    ) {
      return (
        <>
          <CrumbsProvider title="Документация СУБ" link="/manual/" />
          <BigError
            title="Раздел на найден"
            message={`Не найден указанный раздел (${this.state.structure}) в структуре документации`}
          />
        </>
      );
    }

    //Render editor
    if (this.state.mode === "add" || this.state.mode === "edit") {
      return (
        <>
          {!this.state.pending &&
          (this.state.treeVisible || this.state.foldersVisible) ? (
            <div className="container mt-15">
              <ManualCrumbs
                baseUrl="/manual"
                baseName="Документация СУБ"
                items={this.state.structureItems}
                path={this.treeGetPath(this.state.structure)}
                structure={this.state.structure}
                document={this.state.document}
                mode={this.state.mode}
              />
            </div>
          ) : null}
          <TemplateEdit
            structure={this.state.structure}
            document={this.state.document}
            key={this.state.mode === "add" ? "add" : this.state.document}
            id={this.state.mode === "add" ? false : this.state.document}
            add={this.state.mode === "add" ? true : false}
            copyObjId={this.state.copyObjId}
          />
        </>
      );
    }

    let showDocument = false;
    if (this.state.document) {
      showDocument = true;
    }

    return (
      <>
        <CrumbsProvider title="Документация СУБ" link="/manual/" />
        <div className="container">
          {!this.state.pending &&
          (this.state.treeVisible || this.state.foldersVisible) ? (
            <div className="pb-7">
              <ManualCrumbs
                baseUrl="/manual"
                baseName="Документация СУБ"
                items={this.state.structureItems}
                path={this.treeGetPath(this.state.structure)}
                structure={this.state.structure}
                document={this.state.document}
                mode={this.state.mode}
              />
            </div>
          ) : null}

          <div className="row">
            {this.state.treeVisible ? (
              <div className="col-lg-4 m-lg-0 mb-3 manual-left">
                <div className="card card-custom card-stretch">
                  <div className="card-body px-5 py-5">
                    <Blocker on={this.state.pending}>
                      <ManualTree
                        expanded={this.state.structureExpanded}
                        selected={this.state.structureSelected}
                        onNodeToggle={this.treeHandleToggle}
                        onNodeSelect={this.treeHandleSelect}
                        items={this.state.structureItems}
                      />
                    </Blocker>
                  </div>
                </div>
              </div>
            ) : null}
            <div className="col-lg">
              {showDocument ? (
                <>
                  <ManualView
                    structure={this.state.structure}
                    document={this.state.document}
                    onVersionChange={this.onVersionChange}
                    version={this.state.version}
                  />
                </>
              ) : (
                <TemplatesList
                  onChangeView={this.foldersToggleView}
                  wide={!this.state.treeVisible}
                  structure={this.state.structure}
                  mode={this.state.mode}
                  foldersComponent={
                    this.state.foldersVisible ? (
                      <ManualFolders
                        grid={this.state.foldersGrid}
                        wide={!this.state.treeVisible}
                        structure={this.state.structure}
                        structureItems={this.state.structureItems}
                      />
                    ) : null
                  }
                />
              )}
            </div>
          </div>
        </div>
      </>
    );
  }
}
